import { useContext, useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
    const { user, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const dropdownRef = useRef(null);

    const onLogout = () => {
        logout();
        setDropdownOpen(false);
        setMobileMenuOpen(false);
        navigate('/login');
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <nav className="navbar">
            <div className="container">
                <Link to="/" className="logo">
                    <img src="/logo-full.png" alt="Nawiri Chess House" />
                </Link>

                {/* Hamburger Menu Button */}
                <button
                    className="hamburger-btn"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
                    <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
                    <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
                    <Link to="/shop" onClick={() => setMobileMenuOpen(false)}>Shop</Link>
                    <Link to="/about-us" onClick={() => setMobileMenuOpen(false)}>About us</Link>
                    <Link to="/programs" onClick={() => setMobileMenuOpen(false)}>Programs</Link>
                    <Link to="/events" onClick={() => setMobileMenuOpen(false)}>Events</Link>
                    <Link to="/chess-for-schools" onClick={() => setMobileMenuOpen(false)}>Chess for Schools</Link>

                    <div className="profile-dropdown" ref={dropdownRef}>
                        {user && <span className="username">Hi, {user.username}</span>}
                        <button
                            className="profile-icon-btn"
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            aria-label="Profile menu"
                        >
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
                                <path d="M5 20C5 17.5 7.5 15 12 15C16.5 15 19 17.5 19 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>

                        {dropdownOpen && (
                            <div className="dropdown-menu">
                                {user ? (
                                    <>
                                        <Link to="/register" onClick={() => { setDropdownOpen(false); setMobileMenuOpen(false); }}>
                                            Register User
                                        </Link>
                                        <button onClick={onLogout} className="dropdown-item logout-btn">
                                            Logout
                                        </button>
                                    </>
                                ) : (
                                    <Link to="/login" onClick={() => { setDropdownOpen(false); setMobileMenuOpen(false); }}>
                                        Login
                                    </Link>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
